export default __webpack_public_path__ + "static/media/sg-icon.48e0b9b5.webp";